import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CustomerNotification } from "../../../types";
import { AppDispatch } from "../../../redux/store";
import { RootState } from "../../../redux/reducers";
import { toggleDrawer } from "../../../redux/reducers/notification.reducer";
import { selectNotificationDetails } from "../../../redux/selectors/notification.selector";
import NotificationDrawer from "./notification.drawer";

const NotificationIcon = () => {
  const dispatch = useDispatch<AppDispatch>();
//   const notifications = useSelector((state: RootState) => state.notifications.notifications);

  const { notifications } = useSelector((state: RootState) =>
    selectNotificationDetails(state)
  );

  const unreadCount = notifications.filter((notif: CustomerNotification) => !notif.read_at).length;

  const handleIconClick = () => {
    dispatch(toggleDrawer());
  };

  return (
    <>
        <div style={{ position: "relative", cursor: "pointer" }} onClick={handleIconClick}>
        {/* <span style={{ fontSize: "24px" }}>🔔</span> */}
        
        {unreadCount > 0 && (
            <span
            className={`position-absolute bg-danger rounded-circle d-flex align-items-center justify-content-center text-white hw-24 fw-600 p-2 ${unreadCount && unreadCount > 99 ? 'fs-10' : 'fs-12'}`}
            style={{
                
                top: '-8px',
                right: '-8px',
            }}
            >
            {unreadCount && unreadCount > 99 ? '99+' : unreadCount}
            </span>
        )} 
        <img src="../../assets/images/bell-icon.png" alt="" />     
        </div>
        <NotificationDrawer />
    </>
    
  );
};

export default NotificationIcon;
